const numberFormatter = new Intl.NumberFormat('ru-RU');
const dateTimeFormatter = new Intl.DateTimeFormat('ru-RU', {
  dateStyle: 'medium',
  timeStyle: 'short',
});

export function numberFormat(value) {
  return numberFormatter.format(Number(value ?? 0));
}

export function formatPrice(value) {
  if (value === null || value === undefined || Number(value) === 0) return '—';
  return `${numberFormat(value)} ₽`;
}

export function formatDate(dateString) {
  if (!dateString) return '—';
  return dateTimeFormatter.format(new Date(dateString));
}

/**
 * Скрывает точное количество выше порога — для маскировки реальных остатков.
 */
export function formatQuantity(qty, threshold = 20) {
  return Number(qty) > threshold ? `>${threshold}` : Number(qty);
}
